import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import SyncedShipmentList from '../components/Synced_Shipments/SyncedShipmentList';
import EditSyncedShipment from '../components/Synced_Shipments/EditSyncedShipment';


const SyncedShipments = () => {
  return (
    <Routes>
      <Route path="/" element={<SyncedShipmentList />} />
      <Route path="/view/:id" element={<EditSyncedShipment />} />
      <Route path="/view" element={<EditSyncedShipment />} />
    </Routes>
  )
}

export default SyncedShipments;